const PlainRow = ({
  label,
  value,
  color,
}: {
  label: string;
  value: any;
  color?: string;
}) => (
  <div className="flex flex-col gap-1 text-sm sm:flex-row sm:items-start sm:justify-between sm:gap-4">
    <span className="text-black font-medium break-words">{label}</span>
    <span
      className={`text-gray-700 font-medium break-words sm:text-right ${color}`}
    >
      {value ?? "N/A"}
    </span>
  </div>
);

export default PlainRow;
